import { useContext } from "react";
import { IndicatorDashboardContext } from "./IndicatorDashboard.context";

export function useIndicatorDashboardContext(){
    const content = useContext(IndicatorDashboardContext)

    if(!content){
        throw new Error("useIndicatorDashboardContext deve ser utilizado apenas dentro de IndicatorDashboardProvider")
    }
    return content
}